export default "__VITE_ASSET__B9nWe_TU__"